export default function getModuleName() {
  var url = window.location.hash
  url = url.replace("#", "");
  url = url.split("/");
  return url[1] || url[0] || "home";
}
